import styled from "styled-components";

export const CheckboxWrapper = styled.div`
  margin-bottom: 40px;
`;

export const ErrorDiv = styled.div`
  line-height: 1.14;
  color: ${({ secondary }) => (secondary ? "#E59BB2" : "#ac1717")};
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const FlexDiv = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const InputHeader = styled.div`
  font-weight: 600;
  line-height: 1.14;
  color: ${({ secondary }) =>
    secondary ? "rgba(255, 255, 255, 0.9)" : "#242d41"};
  margin-bottom: 8px;
`;

export const InputWrapper = styled.div`
  width: 400px;
  margin-bottom: 24px;
  @media (max-width: 726px) {
    width: 100%;
  }
`;

export const SendUpdatesText = styled.div`
  font-size: 16px;
  line-height: 1.33;
  color: ${({ secondary }) =>
    secondary ? "rgba(255, 255, 255, 0.9)" : "rgba(36, 45, 65, 0.9)"};
  color: a {
    color: #126fd6;
  }
`;

export const StyledCheckbox = styled.input`
  height: 20px;
  width: 20px;
  margin-right: 12px;
  flex-shrink: 0;
  accent-color: #126fd6;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;

export const StyledInput = styled.input`
  height: 50px;
  width: 100%;
  padding-left: 10px;
  border-radius: 4px;
  border: ${({ secondary, error }) => {
    if (secondary) {
      return error ? "solid 1px #E59BB2" : "solid 1px rgba(36, 45, 65, 0.05)";
    } else {
      return error ? "solid 1px #ac1717" : "solid 1px rgba(36, 45, 65, 0.05)";
    }
  }};
  background-color: #f6f8fb;
  font-size: 16px;
  line-height: 1.63;
  color: rgba(36, 45, 65, 0.9);
  &:focus {
    border-color: #126fd6;
  }
  @media (max-width: 451px) {
    width: calc(100vw - 32px);
  }
`;

export const SubmitButton = styled.button`
  height: 46px;
  padding: 0 24px;
  border-radius: 23px;
  border: solid 2px #1e5bb5;
  background-color: #1e5bb5;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  opacity: ${({ disabled }) => (disabled ? "0.3" : "1")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:focus {
    outline: none;
  }
`;

export const SubTitle = styled.p`
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding-right: 124px;
  color: ${({ secondary }) =>
    secondary ? "#ffffff" : "rgba(36, 45, 65, 0.9)"};
  @media (max-width: 726px) {
    padding-right: 0px;
  }
`;
